import { categories } from '@/mocks/categories';

const categoryImages: Record<string, string> = {
  'Shoes': 'https://readdy.ai/api/search-image?query=Trendy%20white%20leather%20sneakers%20on%20minimal%20cream%20background%2C%20clean%20product%20photography%20with%20soft%20natural%20lighting%2C%20fashion%20editorial%20style%2C%20elegant%20presentation%2C%20warm%20neutral%20tones%2C%20isolated%20on%20light%20surface&width=600&height=600&seq=cat-shoes&orientation=squarish',
  'Hoodies': 'https://readdy.ai/api/search-image?query=Oversized%20beige%20hoodie%20sweater%20folded%20neatly%20on%20cream%20surface%2C%20minimalist%20product%20photography%2C%20soft%20natural%20window%20light%2C%20warm%20neutral%20aesthetic%2C%20clean%20composition%2C%20elegant%20casual%20fashion%20presentation&width=600&height=600&seq=cat-hoodies&orientation=squarish',
  'T-Shirts': 'https://readdy.ai/api/search-image?query=Premium%20white%20cotton%20t-shirt%20neatly%20folded%20on%20light%20cream%20background%2C%20minimalist%20product%20photography%2C%20soft%20diffused%20lighting%2C%20clean%20aesthetic%2C%20warm%20neutral%20tones%2C%20editorial%20fashion%20style&width=600&height=600&seq=cat-tshirts&orientation=squarish',
  'Jackets': 'https://readdy.ai/api/search-image?query=Stylish%20light%20beige%20bomber%20jacket%20displayed%20on%20minimal%20cream%20backdrop%2C%20clean%20product%20photography%2C%20soft%20natural%20lighting%2C%20warm%20neutral%20aesthetic%2C%20elegant%20editorial%20presentation&width=600&height=600&seq=cat-jackets&orientation=squarish',
  'Pants': 'https://readdy.ai/api/search-image?query=Modern%20beige%20trousers%20and%20tailored%20shorts%20neatly%20arranged%20on%20cream%20surface%2C%20minimalist%20product%20photography%2C%20soft%20natural%20light%2C%20warm%20neutral%20tones%2C%20clean%20editorial%20style&width=600&height=600&seq=cat-pants&orientation=squarish',
  'Headwear': 'https://readdy.ai/api/search-image?query=Trendy%20baseball%20cap%20and%20beanie%20hat%20on%20minimal%20cream%20background%2C%20clean%20product%20photography%2C%20soft%20natural%20lighting%2C%20warm%20neutral%20aesthetic%2C%20fashion%20editorial%20presentation&width=600&height=600&seq=cat-headwear&orientation=squarish',
  'Sets': 'https://readdy.ai/api/search-image?query=Complete%20fashion%20matching%20set%20of%20hoodie%20and%20joggers%20in%20warm%20neutral%20tone%2C%20minimalist%20product%20photography%20on%20cream%20surface%2C%20soft%20natural%20light%2C%20clean%20aesthetic%2C%20elegant%20editorial%20style&width=600&height=600&seq=cat-sets&orientation=squarish',
  'Underwear': 'https://readdy.ai/api/search-image?query=Premium%20cotton%20underwear%20neatly%20folded%20on%20minimal%20cream%20background%2C%20clean%20product%20photography%2C%20soft%20diffused%20lighting%2C%20warm%20neutral%20aesthetic%2C%20elegant%20editorial%20presentation&width=600&height=600&seq=cat-underwear&orientation=squarish',
  'Jersey': 'https://readdy.ai/api/search-image?query=Stylish%20sports%20jersey%20shirt%20displayed%20on%20minimal%20cream%20backdrop%2C%20clean%20product%20photography%2C%20soft%20natural%20lighting%2C%20warm%20neutral%20aesthetic%2C%20editorial%20fashion%20presentation&width=600&height=600&seq=cat-jersey&orientation=squarish',
  'Accessories': 'https://readdy.ai/api/search-image?query=Trendy%20minimalist%20accessories%20including%20watch%20and%20bracelet%20on%20cream%20surface%2C%20clean%20product%20photography%2C%20soft%20natural%20lighting%2C%20warm%20neutral%20aesthetic%2C%20editorial%20style&width=600&height=600&seq=cat-accessories&orientation=squarish',
  'Bags': 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20leather%20tote%20bag%20on%20cream%20background%2C%20clean%20product%20photography%2C%20soft%20natural%20lighting%2C%20warm%20neutral%20aesthetic%2C%20editorial%20fashion%20presentation&width=600&height=600&seq=cat-bags&orientation=squarish',
  'Belts': 'https://readdy.ai/api/search-image?query=Premium%20leather%20belt%20elegantly%20coiled%20on%20minimal%20cream%20surface%2C%20clean%20product%20photography%2C%20soft%20natural%20lighting%2C%20warm%20neutral%20aesthetic%2C%20editorial%20style&width=600&height=600&seq=cat-belts&orientation=squarish',
  'Perfumes': 'https://readdy.ai/api/search-image?query=Elegant%20fragrance%20bottle%20on%20minimal%20cream%20background%2C%20clean%20product%20photography%2C%20soft%20natural%20lighting%2C%20warm%20neutral%20aesthetic%2C%20luxury%20editorial%20presentation&width=600&height=600&seq=cat-perfumes&orientation=squarish',
  'Other': 'https://readdy.ai/api/search-image?query=Various%20fashion%20accessories%20and%20lifestyle%20items%20arranged%20on%20minimal%20cream%20surface%2C%20clean%20product%20photography%2C%20soft%20natural%20lighting%2C%20warm%20neutral%20aesthetic%2C%20editorial%20style&width=600&height=600&seq=cat-other&orientation=squarish',
};

export default function CategoryGrid() {
  const leftCol = categories.slice(0, 5);
  const midCol = categories.slice(5, 10);
  const rightCol = categories.slice(10, 14);

  return (
    <section className="py-16 md:py-24 px-4 md:px-8 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-start gap-6 mb-12">
          <div className="lg:w-[55%]">
            <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-900 leading-tight">
              Каталог<br />товаров
            </h2>
          </div>
          <div className="lg:w-[45%] lg:pt-4">
            <p className="text-sm md:text-base text-foreground-500 font-body leading-relaxed">
              Быстрый доступ ко всем категориям товаров. Выберите нужный раздел и перейдите к покупкам на основном сайте.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {/* Left column */}
          <div className="flex flex-col gap-5">
            {leftCol.map((cat) => (
              <a
                key={cat.slug}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="group block bg-background-100 rounded-2xl overflow-hidden hover:-translate-y-2 transition-all duration-300 cursor-pointer"
              >
                <div className="h-36 md:h-44 w-full overflow-hidden">
                  <img
                    src={categoryImages[cat.slug] || categoryImages['Other']}
                    alt={cat.name}
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                  />
                </div>
                <div className="p-4">
                  <h3 className="font-body text-base font-semibold text-foreground-900 whitespace-nowrap">{cat.name}</h3>
                  <p className="mt-1 text-xs text-foreground-500 font-body leading-relaxed">
                    Смотреть товары &rarr;
                  </p>
                </div>
              </a>
            ))}
          </div>

          {/* Middle column */}
          <div className="flex flex-col gap-5">
            {midCol.map((cat) => (
              <a
                key={cat.slug}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="group block bg-background-100 rounded-2xl overflow-hidden hover:-translate-y-2 transition-all duration-300 cursor-pointer"
              >
                <div className="p-4 text-center">
                  <h3 className="font-body text-base font-semibold text-foreground-900 whitespace-nowrap">{cat.name}</h3>
                </div>
                <div className="h-36 md:h-44 w-full overflow-hidden">
                  <img
                    src={categoryImages[cat.slug] || categoryImages['Other']}
                    alt={cat.name}
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                  />
                </div>
              </a>
            ))}
          </div>

          {/* Right column */}
          <div className="flex flex-col gap-5">
            {rightCol.map((cat) => (
              <a
                key={cat.slug}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="group block bg-background-100 rounded-2xl overflow-hidden hover:-translate-y-2 transition-all duration-300 cursor-pointer"
              >
                <div className="p-4 text-center">
                  <h3 className="font-body text-base font-semibold text-foreground-900 whitespace-nowrap">{cat.name}</h3>
                </div>
                <div className="h-36 md:h-44 w-full overflow-hidden">
                  <img
                    src={categoryImages[cat.slug] || categoryImages['Other']}
                    alt={cat.name}
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                  />
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}